import { useAtomValue } from 'jotai/react'
import React, { createContext, PropsWithChildren, useContext, useEffect, useState } from 'react'

import { ChainInfo, FromChain, ToChain, useChainInfo } from '@/hooks/services/useChainInfo'
import { TokenInfo, TokenMeta, useTokenInfo } from '@/hooks/services/useTokenInfo'
import { chainInfosAtom, fromChainAtom, toChainAtom } from '@/stores/trade'

export type BridgeState = {
  enableTrade: boolean
  chainInfos: ChainInfo[]
  fromChain?: FromChain
  toChain?: ToChain
  tokenInfos?: TokenInfo[]
  fromToken?: TokenMeta
  toToken?: TokenMeta
  tokenInfo?: TokenInfo
  setTokenInfo: React.Dispatch<React.SetStateAction<TokenInfo | undefined>>
}

const BridgeContext = createContext<BridgeState>({} as BridgeState)

export const useBridgeContext = () => useContext(BridgeContext)

const BridgeProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const chainInfos = useAtomValue(chainInfosAtom)
  const fromChain = useAtomValue(fromChainAtom)
  const toChain = useAtomValue(toChainAtom)

  const { enableTrade } = useChainInfo()
  const { tokenInfos } = useTokenInfo()

  const [tokenInfo, setTokenInfo] = useState<TokenInfo>()
  console.log('>>>>>> tokenInfo: ', tokenInfo)

  useEffect(() => {
    setTokenInfo(tokenInfos?.[0])
  }, [tokenInfos])

  return (
    <BridgeContext.Provider
      value={{
        enableTrade,
        chainInfos,
        fromChain,
        toChain,
        tokenInfos,
        fromToken: tokenInfo?.fromToken,
        toToken: tokenInfo?.toToken,
        tokenInfo,
        setTokenInfo
      }}
    >
      {children}
    </BridgeContext.Provider>
  )
}

export default BridgeProvider
